<template>
  <div class='airWrap'>
    <div class='airInfoList'>
      <div class='airInfo-item' @click='openAirInfo(item.serId)' v-for="item in airInfoList" :key='item.serId'>
        <div class=airInfo-name>
          <div>{{item.serName}}</div>
          <div class='time'>{{nowDate}} {{nowTime}}</div>
        </div>
        <div class='airInfo-status'>
          <div :class='["airInfo-img",item.airStatus==1?"airInfo-img-gif":"airInfo-img-png"]'></div>
          <div class='airInfo-errorInfo'>
            <div><span>在线状态：</span><span :class="['airLamp',item.status==1?'airLampNormal':'airLampError']"></span><span :class="item.status==1?'airOnLine':'airOffLine'">{{item.status==1?'在线':'离线'}}</span></div>
            <div><span>空调状态：</span><span :class='["airLamp",(item.error==1||item.error==7)?"airLampError":"airLampNormal"]'></span><span :class="(item.error==1||item.error==7)?'airOffLine':'airOnLine'">{{(item.error==1||item.error==7)?'故障':'正常'}}</span></div>
            <div><span>空调通信：</span><span :class='["airLamp",(item.error==2||item.error==6)?"airLampError":"airLampNormal"]'></span><span :class="(item.error==2||item.error==6)?'airOffLine':'airOnLine'">{{(item.error==2||item.error==6)?'故障':'正常'}}</span></div>
            <div v-if='item.ctrlSluice==1?true:false'><span>闸门通信：</span><span :class='["airLamp",(item.error==4||item.error==6)?"airLampError":"airLampNormal"]'></span><span :class="(item.error==4||item.error==6)?'airOffLine':'airOnLine'">{{(item.error==4||item.error==6)?'故障':'正常'}}</span></div>
          </div>
        </div>
        <div class='airInfo-runData'>
          <div class='airInfo-left'>
            <div class='airInfo-bgColor'><span class='airInfo-title'>温度：</span><span class='airInfo-wrap'>{{item.realTemp/10}}℃</span></div>
            <div><span class='airInfo-title'>机组状态：</span><span class='airInfo-wrap'>{{item.sysStatus==0?'机组关机':(item.sysStatus==1?'机组开机':'正在关机')}}</span></div>
            <div class='airInfo-bgColor' v-if='item.ctrlSluice==1?true:false'><span class='airInfo-title'>进风闸：</span><span class='airInfo-wrap'>{{item.sluiceList[0].sluiceStatus==1?'正在开':(item.sluiceList[0].sluiceStatus==2?'正在关':(item.sluiceList[0].sluiceStatus==3?'关闭':'开启'))}}</span></div>
            <div :class="item.ctrlSluice==0?'airInfo-bgColor':''"><span class='airInfo-title'>运行能耗：</span><span class='airInfo-wrap'>{{item.energy}}Kwh</span></div>
          </div>
          <div class='airInfo-right'>
            <div class='airInfo-bgColor'><span class='airInfo-title'>运行状态：</span><span class='airInfo-wrap'>{{item.airStatus==1?'开机':'关机'}}</span></div>
            <div><span class='airInfo-title'>运行时常：</span><span class='airInfo-wrap'>{{item.hour}}h</span></div>
            <div class='airInfo-bgColor' v-if='item.ctrlSluice==1?true:false'><span class='airInfo-title'>出风闸：</span><span class='airInfo-wrap'>{{item.sluiceList[1].sluiceStatus==1?'正在开':(item.sluiceList[1].sluiceStatus==2?'正在关':(item.sluiceList[1].sluiceStatus==3?'关闭':'开启'))}}</span></div>
            <div :class="item.ctrlSluice==0?'airInfo-bgColor':''"><span class="airInfo-title">总能耗：</span><span class='airInfo-wrap'>{{item.totalEnergy}}Kwh</span></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog 
      :title="`${airInfo.serName}空调机详情`" 
      :visible.sync="isShow" 
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-bg"' 
      @opened='openAirDialog' 
      @closed='closeAirDialog'>
      <div class='formWrap'>
        <div class='dialog-airInfo-wrap'>
          <div class='airModeList' v-if='airInfo.airMode&&airInfo.airMode>-1'>
            <div :class='{airModeActive:airInfo.airMode==0}' @click='setAirMode(0)'>制冷</div>
            <div :class='{airModeActive:airInfo.airMode==1}' @click='setAirMode(1)'>制热</div>
            <div :class='{airModeActive:airInfo.airMode==2}' @click='setAirMode(2)'>除湿</div>
            <div :class='{airModeActive:airInfo.airMode==3}' @click='setAirMode(3)'>送风</div>
            <div :class='{airModeActive:airInfo.airMode==4}' @click='setAirMode(4)'>自动</div>
          </div>
          <div class='echart-wrap'>
            <div ref='airTempShow' class='airTempShow'></div>
            <div id='setAirTemp'>设定温度：{{airInfo.setupTemp/10}}℃</div>
          </div>
          <div class='airBtnList'>
            <div :class='["airBtnItem",{airBtnItemActive:isPlus}]' @click='tempPlus'>
              <span class='airBtnIcon airBtnIcon1'></span>
              <span>温度</span>
            </div>
            <div :class='["airBtnItem",{airBtnItemActive:isReduce}]' @click='tempReduce'>
              <span class='airBtnIcon airBtnIcon2'></span>
              <span>温度</span>
            </div>
            <div :class='["airBtnItem",{airBtnItemActive:isSweep}]' @click='setSweep' v-if='airInfo.sweep&&airInfo.sweep>-1'>
              <span class='airBtnIcon airBtnIcon3'></span>
              <span>扫风</span>
            </div>
            <div :class='["airBtnItem",{airBtnItemActive:isReset}]' @click='airReset'>
              <span class='airBtnIcon airBtnIcon4'></span>
              <span>复位</span>
            </div>
            <div :class='["airBtnItem",{airBtnItemActive:airInfo.airStatus==1}]' @click='airTurnOn'>
              <span class='airBtnIcon airBtnIcon5'></span>
              <span>开关</span>
            </div>
          </div>
          <div class='airSpeedWrap' v-if='airInfo.airSpeed&&airInfo.airSpeed>-1'>
            风速：
            <div :class="['windSpeed','windSpeed1',{windSpeedActive:airInfo.airStatus==1}]" @click='setAirSpeed(1)'></div>
            <div :class="['windSpeed','windSpeed2',{windSpeedActive:(airInfo.airSpeed>1&&airInfo.airStatus==1)||(airInfo.airSpeed==0&&airInfo.airStatus==1)}]" @click='setAirSpeed(2)'></div>
            <div :class="['windSpeed','windSpeed3',{windSpeedActive:(airInfo.airSpeed>2&&airInfo.airStatus==1)||(airInfo.airSpeed==0&&airInfo.airStatus==1)}]" @click='setAirSpeed(3)'></div>
            <div :class="['windSpeed','windSpeed4',{windSpeedActive:(airInfo.airSpeed==0&&airInfo.airStatus==1)}]" @click='setAirSpeed(0)'>AUTO</div>
          </div>
        </div>
        <div class='dialog-sluice-wrap' v-if='airInfo.ctrlSluice==1||airErrorList.length>0'>
          <div v-if='airInfo.ctrlSluice==1'>
            <div>闸门控制模式：{{airInfo.ctrlMode==1?'远程':'手动'}}</div>
            <div class='sluiceInfo-wrap'>
              <div class='sluiceInfo sluiceLeft'>
                <div class='sluiceCtrl'>
                  <div class='sluiceTitle'>进风闸门</div>
                  <div class='sluiceSwitch'>
                    <el-switch 
                    v-model="switchLeft"
                    @change="switchChange($event,'left')"
                    ></el-switch>
                  </div>
                </div>
                <div class='sluiceStatus'>
                  <div><span class='sluiceStatus-name'>闸门状态：</span><span class='sluiceStatus-value'>{{airInfo.sluiceList[0].sluiceStatus==0?'停止':(airInfo.sluiceList[0].sluiceStatus==1?'正在开':(airInfo.sluiceList[0].sluiceStatus==2?'正在关':(airInfo.sluiceList[0].sluiceStatus==3?'关闭':'开启')))}}</span></div>
                  <div><span class='sluiceStatus-name'>闸门开度：</span><span class='sluiceStatus-value'>{{airInfo.sluiceList[0].openScale}}</span></div>
                  <div><span class='sluiceStatus-name'>故障信息：</span><span :class='["sluiceStatus-value",airInfo.sluiceList[0].error==0?"sluiceStatus-success":"sluiceStatus-error"]'>{{airInfo.sluiceList[0].error==0?"正常":'故障'}}</span></div>
                </div>
              </div>
              <div class='sluiceInfo sluiceRight'>
                <div class='sluiceCtrl'>
                  <div class='sluiceTitle'>出风闸门</div>
                  <div class='sluiceSwitch'>
                    <el-switch 
                    v-model="switchRight"
                    @change="switchChange($event,'right')"
                    ></el-switch>
                  </div>
                </div>
                <div class='sluiceStatus'>
                  <div><span class='sluiceStatus-name'>闸门状态：</span><span class='sluiceStatus-value'>{{airInfo.sluiceList[1].sluiceStatus==0?'停止':(airInfo.sluiceList[1].sluiceStatus==1?'正在开':(airInfo.sluiceList[1].sluiceStatus==2?'正在关':(airInfo.sluiceList[1].sluiceStatus==3?'关闭':'开启')))}}</span></div>
                  <div><span class='sluiceStatus-name'>闸门开度：</span><span class='sluiceStatus-value'>{{airInfo.sluiceList[1].openScale}}</span></div>
                  <div><span class='sluiceStatus-name'>故障信息：</span><span :class='["sluiceStatus-value",airInfo.sluiceList[1].error==0?"sluiceStatus-success":"sluiceStatus-error"]'>{{airInfo.sluiceList[1].error==0?'正常':'故障'}}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if='airErrorList.length>0'>
            <div style='font-weight:550;color:#3562ff'>空调故障信息</div>
            <div class='airErrorList' :style="{height:airInfo.ctrlSluice==1?'100px':'170px'}">
              <div class='airErrorItem' v-for="(event,index) in airErrorList" :key='index'>{{index+1}}、{{event}}</div>
            </div>
          </div>
         
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShow = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js';
import tool from '../../tool.js'
export default {
  props:{
    wareId:Number
  },
  data(){
    return{
      airInfoList:[],
      nowDate:null,
      nowTime:null,
      timer1:'',
      isShow:false,
      isMode:0,
      serId:'',
      timer2:'',
      airInfo:{},
      realTemp:0,
      airTempShow:'',
      loading:'',
      isReset:false,
      isSweep:false,
      isReduce:false,
      isPlus:false,
      switchLeft:false,
      switchRight:false,
      airErrorList:[],
      newWareId:this.wareId
    }
  },
  watch: {
    wareId(newV, oldV) { 
      this.newWareId=newV;
      this.getAirStatus()
    }
  },
  created(){
    this.getAirStatus();
    this.timer1=setInterval(this.getTime,1000);
  },
  beforeDestroy() {
    if (this.timer1) {
      clearInterval(this.timer1); 
    }
  },
  methods:{
    getTime(){
      const date=new Date();
      const year=date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour= date.getHours();
      const minute = date.getMinutes();
      this.month=check(month);
      this.day=check(day);
      this.hour=check(hour);
      this.minute=check(minute);
      function check(i){
        const num = (i<10)?("0"+i) : i;
        return num;
      }
      this.nowDate=year+'-'+month+'-'+day;
      this.nowTime=hour+':'+minute;
      this.getAirStatus()
    },
    getAirStatus(){
      axios.get(`/system/air/getAirByWareId/${this.newWareId}`).then(data=>{
        this.airInfoList=data.data;
      })
    },
    openAirInfo(serId){
      this.isShow=true;
      this.serId=serId;
      this.getAirStatusById()
    },
    getAirStatusById(){
      axios.get(`/system/air/getAirBySerId/${this.serId}`).then(data=>{
        this.airInfo=data.data;
        if(data.data.length>0){
          this.airErrorList=data.data.errorInfo.split(';')
        }else{
          this.airErrorList=[]
        }
        if(data.data.ctrlSluice==1){
          this.switchLeft=(data.data.sluiceList[0].sluiceStatus==1||data.data.sluiceList[0].sluiceStatus==4)?true:false
          this.switchRight=(data.data.sluiceList[0].sluiceStatus==1||data.data.sluiceList[0].sluiceStatus==4)?true:false
        }
        if(this.airTempShow==""){
          this.airTempShow=this.$echarts.init(this.$refs.airTempShow,null,{
            width:290,
            height:200
          });
        }
        this.drawEcharts()
      })
    },
    openAirDialog(){
      this.timer2=setInterval(this.getAirStatusById,1000)
    },
    closeAirDialog(){
      clearInterval(this.timer2)
    },
    drawEcharts(){
      let option;
      option={
        series:[{
          type:'gauge',
          center:['50%','60%'],
          startAngle:200,
          endAngle:-20,
          min:-20,
          max:80,
          splitNumber:10,
          itemStyle:{color:'#ffab91'},
          progress:{
            show:true,
            width:10,
            roundCap:true
          },
          pointer:{show:false},
          axisLine:{
            roundCap:true,
            lineStyle:{width:10}},
          axisTick:{
            distance:-20,
            splitNumber:5,
            lineStyle:{
              width:1,
              color:'#999'
            }
          },
          splitLine:{
            distance:-24,
            length:8,
            lineStyle:{
              width:1.5,
              color:"#999"
            }
          },
          axisLabel:{
            distance:-15,
            color:'#999',
            fontSize:'10px'
          },
          title:{show:false},
          anchor:{show:false},
          detail:{
            valueAnimation:true,
            width:'60%',
            lineHeight:30,
            borderRadius:8,
            offsetCenter:[0,'-5%'],
            fontSize:24,
            fontWeight:'bolder',
            formatter:"{value} ℃",
            color:'auto'
          },
          data:[{value:this.airInfo.realTemp/10}]
        },{
          type:'gauge',
          center:['50%','60%'],
          startAngle:200,
          endAngle:-20,
          min:-20,
          max:80,
          splitNumber:10,
          itemStyle:{color:'#fd7347'},
          progress:{
            show:true,
            width:3,
            roundCap:true
          },
          pointer:{show:false},
          axisLine:{show:false},
          axisTick:{show:false},
          splitLine:{show:false},
          axisLabel:{show:false},
          title:{show:false},
          anchor:{show:false},
          detail:{show:false},
          data:[{value:this.airInfo.realTemp/10}]
        }]
      }
      this.airTempShow.setOption(option)
    },
    setAirMode(num){
      if(this.airInfo.airStatus==1){
        let that=this;
        this.airInfo.airMode=num;
        clearInterval(this.timer2);
        tool.debounce(function(){
          that.setLoading()
          axios.post('/system/air/upsetAirMode',{airMode:num,serId:that.airInfo.serId}).then(data=>{
            that.loading.close()
            if(data){
              that.$message({
                message:data.msg,
                type:'success',
                duration:1000,
              })
              that.timer2=setInterval(that.getAirStatusById,1000)
            }
          })
        },2000)(num)
      }else{
        this.$message({
          message:'空调还未打开！',
          type:'info',
          duration:1000,
        })
      }
    },
    // 设置加载动画
    setLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-bg')
      })
    },
    //开关
    airTurnOn(){
      let turnOn=0;
      if(this.airInfo.airStatus==1){
        turnOn=0
      }else{
        turnOn=1
      }
      this.setLoading()
      axios.post('/system/air/controlAir',{turnOn:turnOn,serId:this.airInfo.serId}).then(data=>{
        this.loading.close()
        if(data){
          this.$message({
            message:data.msg,
            type:'success',
            duration:1000,
          })
        }
      })
    },
    //重置
    airReset(){
      if(this.airInfo.airStatus==1){
        this.isReset=true;
        this.pubMethod('/system/air/reset',{serId:this.airInfo.serId},'reset')
      }else{
        this.$message({
          message:'空调还未打开！',
          type:'info',
          duration:1000,
        })
      }
    },
    //设定是否扫风
    setSweep(){
      if(this.airInfo.airStatus==1){
        let sweep=0;
        if(this.airInfo.sweep==1){
          sweep=0
        }else{
          sweep=1
        }
        this.isSweep=true
        this.pubMethod('/system/air/upsetSweep',{serId:this.airInfo.serId,sweep:sweep},'sweep')
      }else{
        this.$message({
          message:'空调还未打开！',
          type:'info',
          duration:1000,
        })
      }
    },
    // 温度减
    tempReduce(){
      if(this.airInfo.airStatus==1){
        let setTemp=this.airInfo.setupTemp;
        this.isReduce=true
        if(setTemp){
          setTemp=parseInt(setTemp)/10
        }else{
          setTemp=0
        }
        setTemp-=1;
        if(setTemp<-20){
          setTemp=-20
        }
        this.airInfo.setupTemp=setTemp*10;
        clearInterval(this.timer2)
        this.upsetAirTemp('reduce')
      }else{
        this.$message({
          message:'空调还未打开！',
          type:'info',
          duration:1000,
        })
      }
    },
    // 温度加
    tempPlus(){
      if(this.airInfo.airStatus==1){
        let setTemp=this.airInfo.setupTemp;
        this.isPlus=true
        if(setTemp){
          setTemp=parseInt(setTemp)/10
        }else{
          setTemp=0
        }
        setTemp+=1;
        if(setTemp>80){
          setTemp=80
        }
        this.airInfo.setupTemp=setTemp*10;
        clearInterval(this.timer2)
        this.upsetAirTemp('plus')
      }else{
        this.$message({
          message:'空调还未打开！',
          type:'info',
          duration:1000,
        })
      }
    },
    // 设定风速
    setAirSpeed(num){
      if(this.airInfo.airStatus==1){
        clearInterval(this.timer2);
        this.airInfo.airSpeed=num;
        let that=this;
        tool.debounce(()=>{
          that.setLoading();
          axios.post('/system/air/upsetAirSpeed',{airSpeed:that.airInfo.airSpeed,serId:that.airInfo.serId}).then(data=>{
            that.loading.close();
            if(data){
              that.$message({
                message:data.msg,
                type:'success',
                duration:1000,
              })
              that.timer2=setInterval(that.getAirStatusById,1000)
            }
          })
        },3000)()
      }else{
        this.$message({
          message:'空调还未打开！',
          type:'info',
          duration:1000,
        })
      }
    },
    upsetAirTemp(str){
      let that=this;
      tool.debounce(()=>{
        that.setLoading();
        axios.post('/system/air/upsetAirTemp',{temp:that.airInfo.setupTemp,serId:that.airInfo.serId}).then(data=>{
          that.loading.close()
          if(str=='reduce'){
            setTimeout(()=>{
             that.isReduce=false
            },3000)
          }else if(str=='plus'){
            setTimeout(()=>{
              that.isPlus=false
            },3000)
          }
          if(data){
            that.$message({
              message:data.msg,
              type:'success',
              duration:1000,
            })
            that.timer2=setInterval(that.getAirStatusById,1000)
          }
        })
      },2000)(str)
    },
    pubMethod(url,parms,str){
      this.setLoading();
      clearInterval(this.timer2)
      axios.post(url,parms).then(data=>{
        this.loading.close()
        if(str=='sweep'){
          setTimeout(()=>{
            this.isSweep=false
          },3000)
        }else if(str=='reset'){
          setTimeout(()=>{
            this.isReset=false
          },3000)
        }
        if(data){
          this.$message({
            message:data.msg,
            type:'success',
            duration:1000,
          })
          setTimeout(()=>{
            this.timer2=setInterval(this.getAirStatusById,1000)
          },2000)
        }
      })
    },
    switchChange(e,str){
      let params={};
      let status=0;
      if(e){
        status=1
      }else{
        status=2
      }
      if(str=='left'){
        params={state:[status,255],serId:this.airInfo.serId}
      }else{
        params={state:[255,status],serId:this.airInfo.serId}
      }
      this.pubMethod('/system/sluice/upsetSluice',params)
    }
  }
}
</script>

<style>
  .airInfo-item{
    width: 336px;
    height: 263px;
    background: rgba(255,255,255,0.63);
    box-shadow:0 1px 1px 0 #ffffff,
              0 3px 7px 0 rgba(0,0,0,0.15);
    border-radius: 8px;
    overflow: hidden;
    margin-top: 35px;
    margin-left:59px;
    font-size: 12px;
    float: left;
    cursor: pointer;
  }
  .airInfo-name{
    width: 100%;
    height: 30px;
    background: #325DFB;
    line-height: 30px;
    color: white;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px 0 17px;
    box-sizing: border-box
  }
  .airInfo-status{
    display: flex;
    justify-content: space-between;
    padding: 12px 13px 12px 9px;
  }
  .airInfo-img{
    height: 89px;
    width: 132px;
  }
  .airInfo-img-png{
    background-image: url('../../assets/air/air.png');
    background-size: cover
  }
  .airInfo-img-gif{
    background-image: url('../../assets/air/air.gif');
    background-size: cover
  }
  .airInfo-errorInfo{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center
  }
  .airInfo-errorInfo div{
    display: flex;
    align-items: center;
  }
  .airLamp{
    background: #8b8b8b;
    height:6px;
    width: 6px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
  }
  .airLampNormal{
    background: #31C073
  }
  .airLampError{
    background: #c03131
  }
  .airOnLine{color: #31C073}
  .airOffLine{color: #c03131}
  .airInfo-runData{
    height: 120px;
    display: flex;
  }
  .airInfo-left,.airInfo-right{
    height: 100%;
    width: 50%;
    box-sizing: border-box;
    
  }
  .airInfo-left div,.airInfo-right div{
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content:center
  }
  .airInfo-left{
    border-right: 1px solid rgba(0,0,0,0.12)
  }
  .airInfo-bgColor{
    background-color: rgba(217,217,217,0.3)
  }
  .airInfo-wrap,.airInfo-title{
    display: inline-block;
    width: 90px;
    text-align: end;
  }
  .airInfo-title{
    width: 60px
  }
  .dialog-bg{
    width: 732px !important
  }

  .dialog-airInfo-wrap,.dialog-sluice-wrap{
    height: 336px;
    width: 336px;
    background: rgba(255,255,255,0.63);
    box-shadow: inset 0 1px 1px 0 #fff,
    0 3px 7px 0 rgba(0,0,0,0.09);
    border-radius: 8px;
    padding: 12px;
    box-sizing: border-box;
    font-size: 12px
  }
  .dialog-airInfo-wrap{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .airModeList{
    display: flex;
    height: 30px;
    border-radius: 15px;
    background-color: #EDF1FB;
    line-height: 30px;
    width: 310px
  }
  .airModeList div{
    height: 30px;
    width: 62px;
    border-radius: 15px;
    text-align: center;
    font-weight: 550;
    cursor: pointer;
  }
  .airModeActive{
    background-color: #3562ff;
    color:white
  }
  .echart-wrap{
    height: 170px;
    width: 290px;
    position: relative;
  }
  .airTempShow{
    height: 170px;
    width: 290px;
    overflow: hidden;
  }
  #setAirTemp{
    font-size: 12px;
    font-weight: 550;
    color:#6385FF;
    position: absolute;
    top: 5px;
    right:0;
  }
  .airBtnList{
    display: flex;
    justify-content: space-around;
    width: 310px
  }
  .airBtnItem{
    height: 53px;
    width: 53px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(27,41,172,.2);
    border-radius: 10px;
    cursor: pointer;
    font-weight: 550;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
  }
  .airBtnItemActive{
    background:#3562ff;
    color: white
  }
  .airBtnIcon{
    display: block;
    width:18px;
    height: 18px;
    background-size: cover
  }
  .airBtnIcon1{
    background-image: url('../../assets/icon/plus.png')
  }
  .airBtnItemActive .airBtnIcon1{
    background-image: url('../../assets/icon/plus-active.png');
  }
  .airBtnIcon2{
    background-image: url('../../assets/icon/reduce.png')
  }
  .airBtnItemActive .airBtnIcon2{
    background-image: url('../../assets/icon/reduce-active.png');
  }
  .airBtnIcon3{
    background-image: url('../../assets/icon/reduce.png')
  }
  .airBtnItemActive .airBtnIcon3{
    background-image: url('../../assets/icon/reduce-active.png');
  }
  .airBtnIcon4{
    background-image: url('../../assets/icon/update.png')
  }
  .airBtnItemActive .airBtnIcon4{
    background-image: url('../../assets/icon/update-active.png');
  }
  .airBtnIcon5{
    background-image: url('../../assets/icon/off.png')
  }
  .airBtnItemActive .airBtnIcon5{
    background-image: url('../../assets/icon/on.png');
  }
  .airSpeedWrap{
    display: flex;
    height: 16px;
    line-height: 16px
  }
  .windSpeed{
    width: 64px;
    height: 16px;
    background-color: #D9D9D9;
    margin-right: 5px;
    cursor: pointer;
  }
  .windSpeed1{
    border-radius: 8px 0 0 8px
  }
  .windSpeed4{
    border-radius: 0 8px 8px 0;
    text-align: center;
    font-weight: 550;
    margin:0
  }
  .windSpeedActive{
    background-color: #6385FF;
    color: white
  }
  .dialog-sluice-wrap{
    padding: 15px
  }
  .sluiceInfo-wrap{
    display: flex;
    justify-content: space-between;
    margin:11px 0
  }
  .sluiceInfo{
    height: 144px;
    width: 144px;
    background: #fff;
    border: 1px solid rgba(0,0,0,0.18);
    border-radius: 11px;
    padding: 11px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column
  }
  .sluiceCtrl{
    display: flex;
    justify-content: space-between;
    height:25px;
    line-height: 16px;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid rgba(0,0,0,0.14)
  }
  .sluiceStatus{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-top: 5px;
    box-sizing: border-box;
    font-weight: 500
  }
  .sluiceStatus div{
    display: flex;
    justify-content: space-between
  }
  .sluiceStatus-value{
    display: inline-block;
    width: 40px;
    text-align: center
  }
  .sluiceStatus-error{
    color: #c03131
  }
  .sluiceStatus-success{
    color: #3562ff
  }
  .airErrorList{
    padding:5px 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    margin-top: 10px
  }
  .airErrorItem{
    width: 50%;
    height: 25px;
    line-height: 25px;
    color: #c03131
  }
</style>